import constants from '../../../constants/constants'
import isSystemStyle from '../../../theme/isSystemStyle'
import type {DsFixer} from '../../dsDataFixers'
import type {Pointer, PS} from '@wix/document-services-types'
import type {RelationshipsAPI} from '@wix/document-manager-extensions'
import type {DalItem} from '@wix/document-manager-core'

const {MASTER_PAGE_ID, STYLES} = constants
const {COMPONENT_STYLE, TOP_LEVEL_STYLE} = STYLES

const getOwnerDataNode = (ps: PS, stylePointer: Pointer): DalItem | undefined => {
    const {relationships} = ps.extensionAPI as RelationshipsAPI
    const [ownerPointer] = relationships.getOwningReferencesToPointer(stylePointer)
    return ownerPointer && ps.dal.get(ownerPointer)
}

const getStylePage = (ps: PS, stylePointer: Pointer): string => {
    const owner = getOwnerDataNode(ps, stylePointer)
    return owner?.metaData?.pageId ?? MASTER_PAGE_ID
}

const exec = (ps: PS) => {
    const newStyleProperties = {
        styleType: STYLES.TYPES.CUSTOM,
        type: ps.runtimeConfig.stylesPerPage ? COMPONENT_STYLE : TOP_LEVEL_STYLE
    }

    const invalidStylesPointers = ps.pointers.data.getStyleItemsWithPredicate(
        ({id, type}) => type === TOP_LEVEL_STYLE && !isSystemStyle(ps, id),
        MASTER_PAGE_ID
    )

    for (const invalidStylePointer of invalidStylesPointers) {
        const invalidStyle = ps.dal.get(invalidStylePointer)

        const pointerWithPageId = ps.runtimeConfig.stylesPerPage
            ? ps.pointers.getPointer(invalidStylePointer.id, invalidStylePointer.type, {
                  pageId: getStylePage(ps, invalidStylePointer)
              })
            : invalidStylePointer

        const fixedStyle = {...invalidStyle, ...newStyleProperties}
        ps.dal.set(pointerWithPageId, fixedStyle)
    }
}

const fixer: DsFixer = {
    exec,
    name: 'unknownSystemStylesFixer',
    version: 1
}
export default fixer
